import type { BookingListRow } from "./bookingViewModel";
import { bookingPartyCount } from "./bookingPartyCount";

/** Total people across bookings (any activity type). */
export function totalGuests(bookings: BookingListRow[]): number {
  return bookings.reduce((sum, booking) => sum + bookingPartyCount(booking), 0);
}
